export default [
  {
    path: '/example-new',
    name: 'New example',
    component: () => import('./ExampleForm'),
    meta: {
      routerBack: 'example',
      domain: 'example',
      sidebar: false,
      title: 'New Example',
      icon: 'keyboard_backspace',
    },
    children: [
      {
        name: 'Edit example',
        path: '/example-edit/:id',
        meta: {
          sidebar: false,
          routerBack: '/example',
          domain: 'Example',
          title: 'Edit example',
          icon: 'edit',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Example/ExampleForm/FormRouter.js